import { TApiResponse } from '@/common/types/response';

import { DEFAULT_CROSS_CUTTING_TASK } from './const';
import { crossCuttingTaskState } from './types';


export function setCrossCuttingTaskMpk(
  state: crossCuttingTaskState,
  res: TApiResponse<crossCuttingTaskState['crossCuttingTask']>,
) {
  const data = res.data;

  if (data && Array.isArray(data.tasksByThematicBlocks) && data.tasksByThematicBlocks.length) {
    state.crossCuttingTask = data;
  } else {
    state.crossCuttingTask = DEFAULT_CROSS_CUTTING_TASK;
  }

}
